
var ur = window.location.href;
if(ur.includes('/one-year-limited-warranty')){
 jQuery(document).ready(function(){
   $('section.home-section.featured-text-container.content-area').eq(2).hide();
$('.warranty-button').click(function(){
  $('.warranty-button').removeClass('active');
  $(this).addClass('active');
  if($(this).hasClass('english')){
   $('section.home-section.featured-text-container.content-area').eq(1).show();
    $('section.home-section.featured-text-container.content-area').eq(2).hide();
  }
  else{
    $('section.home-section.featured-text-container.content-area').eq(2).show();
    $('section.home-section.featured-text-container.content-area').eq(1).hide();
  }
  
}); 
}); 
}
var ur = window.location.href;
if(ur == ('https://www.moneylinetees.com/collections')){
  window.location.href = "/pages/brands"
}

/*
if(ur == ('https://www.moneylinetees.com/collections/parks-and-recreation')){
  window.location.href = "https://www.moneylinetees.com/pages/parks-and-recreation"
}



if(ur == ('https://www.moneylinetees.com/collections/the-office')){
  window.location.href = "https://www.moneylinetees.com/pages/the-office"
}
*/
jQuery(document).ready(function(){

     var dsfsdf = 0; var timerdsfsdf = setInterval(function(){
  if($(".cart-mini-item-row .minus").length) {
   
 $(".cart-mini-item-row .minus").click(function() {
 $(this).parent().find('.product-quantity-increment-down').click()           
           
});
            
$(".cart-mini-item-row  .plus").click(function() {
                $(this).parent().find('.product-quantity-increment-up').click()         
});	
clearInterval(timerdsfsdf);}if( dsfsdf > 1000000000){clearInterval(timerdsfsdf);}dsfsdf++;}, 50);
var sdf = 0; var timersdf = setInterval(function(){
  if($('.cbb-frequently-bought-form').length) {
	 $('.cbb-frequently-bought-form').eq(0).prepend($('.cbb-frequently-bought-discount-message-container'))
clearInterval(timersdf);}if( sdf > 200){clearInterval(timersdf);}sdf++;}, 50);
 
});


var ur = window.location.href;
if(ur.includes('/cart')){
  jQuery(document).ready(function(){


     var dsfsdf = 0; var timerdsfsdf = setInterval(function(){
  if( $(".cart-item .minus").length) {
 $(".cart-item .minus").click(function() {
    
                const clickedElement = event.target; // Assuming this is the element that triggered the event
const parentElement = clickedElement.parentElement;
const inputElement = parentElement.querySelector(".product-quantity-input");

if (inputElement) {
  let currentValue = parseInt(inputElement.value);
  if (!isNaN(currentValue) && currentValue > 1) {
    inputElement.value = currentValue - 1;
    inputElement.dispatchEvent(new Event('change'));
  }
}
                });
            
                $(".cart-item  .plus").click(function() {
                  const inputElement = $(this).parent().find(".product-quantity-input");
                  if (inputElement.length) {
                    let currentValue = parseInt(inputElement.val());
                    if (!isNaN(currentValue)) {
                      inputElement.val(currentValue + 1).change();
                    }
                  }
                });	
clearInterval(timerdsfsdf);}if( dsfsdf > 200){clearInterval(timerdsfsdf);}dsfsdf++;}, 50);

});
  
}

jQuery(document).ready(function(){
$('[href="#tab2"]').click(function(){
  $('.tabs-nav li').removeClass('active')
  $(this).parent().addClass('active')
  $('div#tab1').hide();
  $('div#tab2').show();
}); 
$('[href="#tab1"]').click(function(){
    $('.tabs-nav li').removeClass('active')
  $(this).parent().addClass('active')
  $('div#tab2').hide();
  $('div#tab1').show();
});   
});
 setInterval(function(){ 
$('.quickshop-content a[data-target="size-guide"]').click(function(e){
  e.preventDefault();
    window.location.href="https://www.moneylinetees.com/pages/size-charts"
}); 
}, 1000);
